// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadGiftExportV2MutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type DownloadGiftExportV2Mutation = { __typename?: 'Mutation', exportLifetimeExclusionEventsV2: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    DownloadGiftExportV2: 'DownloadGiftExportV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DownloadGiftExportV2Document = gql`
    mutation DownloadGiftExportV2($householdId: ID!) {
  exportLifetimeExclusionEventsV2(householdID: $householdId) {
    token
    expiresInSeconds
  }
}
    `;
export type DownloadGiftExportV2MutationFn = Apollo.MutationFunction<DownloadGiftExportV2Mutation, DownloadGiftExportV2MutationVariables>;

/**
 * __useDownloadGiftExportV2Mutation__
 *
 * To run a mutation, you first call `useDownloadGiftExportV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGiftExportV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGiftExportV2Mutation, { data, loading, error }] = useDownloadGiftExportV2Mutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useDownloadGiftExportV2Mutation(baseOptions?: Apollo.MutationHookOptions<DownloadGiftExportV2Mutation, DownloadGiftExportV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGiftExportV2Mutation, DownloadGiftExportV2MutationVariables>(DownloadGiftExportV2Document, options);
      }
export type DownloadGiftExportV2MutationHookResult = ReturnType<typeof useDownloadGiftExportV2Mutation>;
export type DownloadGiftExportV2MutationResult = Apollo.MutationResult<DownloadGiftExportV2Mutation>;
export type DownloadGiftExportV2MutationOptions = Apollo.BaseMutationOptions<DownloadGiftExportV2Mutation, DownloadGiftExportV2MutationVariables>;